import { render } from "./ViewSupportDetail.vue?vue&type=template&id=7f6f5e02"
import script from "./ViewSupportDetail.vue?vue&type=script&lang=js"
export * from "./ViewSupportDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__